<template>
  <div class="delivery-quotation-letter" title="Запрос на получение котировки">
    <p style="margin: 0px 0px 5px 0;"><em>Уважаемые коллеги,</em></p>
    <p style="margin: 0px 0px 5px 0;">
      <em>Мы ценим наше сотрудничество и надеемся на долгосрочные партнерские отношения!<br>
        Просим Вас предоставить котировку по следующему запросу:</em>
    </p>
    <br>
    <!-- Тип перевозки -->
    <template v-if="quotation.supply_way">
        <p style="margin: 0px 0px 5px 0;"><strong>Направление перевозки:</strong> {{ quotation.supply_way }}</p>
      </template>
    <!-- Тип перевозки -->
    <template v-if="quotation.transport_types_id">
        <p style="margin: 0px 0px 5px 0;"><strong>Тип перевозки:</strong> {{ getReferenceProperty(quotation.transport_types_id) }}</p>
    </template>

    <!-- Выбранные типы перевозок для расчета -->
    <template v-if="quotation.selected_transport_types_id && quotation.selected_transport_types_id.length">
        <p style="margin: 0px 0px 5px 0;"><strong>Типы перевозок на расчет:</strong> {{ quotation.selected_transport_types_id.map(getReferenceProperty).join(', ') }}</p>
    </template>

    <template v-if="quotation.set_delivery_conditions_ids && quotation.set_delivery_conditions_ids.length">
        <p style="margin: 0px 0px 5px 0;"><strong>Условия поставки:</strong> {{ quotation.set_delivery_conditions_ids.map(getReferenceProperty).join(', ') }}</p>
    </template>
      
    <!-- Место загрузки -->
    <template v-if="quotation.loading_places && quotation.loading_places.length">
        <p style="margin: 0px 0px 5px 0;"><strong>Место загрузки:</strong></p>
        <ul style="padding-left: 15px;">
          <li v-for="(place, index) in quotation.loading_places" :key="`loading-place-${index}`">
            {{ getReferenceProperty(place.country_id) }}<template v-if="place.city">, {{ place.city }}</template>, {{ place.address }}
          </li>
        </ul>
    </template>
    
    <!-- Место разгрузки -->
    <template v-if="quotation.unloading_places && quotation.unloading_places.length">
      <p style="margin: 0px 0px 5px 0;"><strong>Место разгрузки:</strong></p>
      <ul style="padding-left: 15px;">
        <li v-for="(place, index) in quotation.unloading_places" :key="`unloading-place-${index}`">
          {{ getReferenceProperty(place.country_id) }}<template v-if="place.city">, {{ place.city }}</template>, {{ place.address }}
        </li>
      </ul>
    </template>

    <!-- Место растаможки -->
    <template v-if="quotation.clearance_places && quotation.clearance_places.length">
        <p style="margin: 0px 0px 5px 0;"><strong>Место растаможки:</strong></p>
        <ul style="padding-left: 15px;">
            <li v-for="(place, index) in quotation.clearance_places" :key="`clearance-place-${index}`">
            {{ getReferenceProperty(place.country_id) }}<template v-if="place.city">, {{ place.city }}</template>, {{ place.address }}
            </li>
        </ul>
    </template>

    <!-- Место затаможки -->
    <template v-if="quotation.customs_places && quotation.customs_places.length">
        <p style="margin: 0px 0px 5px 0;"><strong>Место затаможки:</strong></p>
        <ul style="padding-left: 15px;">
          <li v-for="(place, index) in quotation.customs_places" :key="`customs-place-${index}`">
            {{ getReferenceProperty(place.country_id) }}<template v-if="place.city">, {{ place.city }}</template>, {{ place.address }}
          </li>
        </ul>
    </template>
  
    <!-- Описание груза -->
    <template v-if="quotation.cargo_name">
        <p style="margin: 0px 0px 5px 0;"><strong>Наименование груза:</strong> {{ quotation.cargo_name }}</p>
    </template>
    <template v-if="quotation.cargo_details">
        <p style="margin: 0px 0px 5px 0;"><strong>Описание груза:</strong> {{ quotation.cargo_details }}</p>
    </template>
    <template v-if="quotation.cargo_code">
        <p style="margin: 0px 0px 5px 0;"><strong>Код ТН ВЭД:</strong> {{ quotation.cargo_code }}</p>
    </template>

    <template v-if="quotation.adr && quotation.adr != 'Не знаю'">
        <p style="margin: 0px 0px 5px 0;"><strong>{{ quotation.adr }}</strong></p>
    </template>
    <template v-if="quotation.stackable && quotation.stackable != 'Не знаю'">
        <p style="margin: 0px 0px 5px 0;"><strong>{{ quotation.stackable }}</strong></p>
    </template>
    <template v-if="quotation.cargoType && quotation.cargoSize">
        <p style="margin: 0px 0px 5px 0;"><strong>{{ quotation.cargoType }}, {{ quotation.cargoSize }}</strong></p>
    </template>
  
    <template v-if="quotation.packaging_type">
        <p style="margin: 0px 0px 5px 0;"><strong>Вид упаковки:</strong> {{ quotation.packaging_type }}</p>
      </template>
      <template v-if="quotation.dimensions.length || quotation.dimensions.width || quotation.dimensions.height || quotation.dimensions.volume || quotation.gross_weight || quotation.number_of_places">
        <p style="margin: 0px 0px 5px 0;"><strong>Размеры и объем груза:</strong>
          <span>
            {{ [
                quotation.gross_weight ? `Вес брутто груза: ${formatNumber(quotation.gross_weight)} кг` : '',
                quotation.dimensions.length ? `Длина: ${quotation.dimensions.length} м` : '',
                quotation.dimensions.width ? `Ширина: ${quotation.dimensions.width} м` : '',
              quotation.dimensions.height ? `Высота: ${quotation.dimensions.height} м` : '',
              quotation.dimensions.volume ? `Объем: ${quotation.dimensions.volume} м³` : '',
              quotation.number_of_places ? `Кол-во мест: ${quotation.number_of_places}` : ''
            ].filter(Boolean).join(', ') }}
          </span>
        </p>
    </template>
    <template v-if="quotation.dimensions.details">
        <p style="margin: 0px 0px 5px 0;"><strong>Подробнее о габаритах:</strong> {{ quotation.dimensions.details }}</p>
    </template>

    <!-- Размеры грузовых мест -->
    <template v-if="quotation.cargo_places && quotation.cargo_places.length">
        <p style="margin: 0px 0px 5px 0;"><strong>Размеры грузовых мест:</strong></p>
        <ul style="padding-left: 15px;">
            <li v-for="(place, index) in quotation.cargo_places" :key="`cargo-place-${index}`">
                {{ place.length }}см x {{ place.width }}см x {{ place.height }}см, 
                {{ place.quantity }} {{ place.quantity === 1 ? 'место' : 'мест' }}<template v-if="place.packaging_type">, {{ place.packaging_type }}</template>
            </li>
        </ul>
    </template>

    <template v-if="quotation.hasOwnProperty('isStackingOfCargo')">
      <p style="margin: 0px 0px 5px 0;"><strong>Штабелировка груза:</strong> {{ quotation.isStackingOfCargo ? 'Можно' : 'Нельзя' }}</p>
    </template>

    <!-- Дата готовности -->
    <template>
        <p style="margin: 0px 0px 5px 0;" v-if="quotation.isIndicative"><strong>Этот запрос - индикатив, поставка возможно не состоится.</strong></p>
        <p style="margin: 0px 0px 5px 0;" v-if="quotation.next_transport_date"><strong>Дата готовности груза: </strong>{{ formattedDate(quotation.next_transport_date)}}</p>
    </template>  
  
    <!-- Типы и виды транспортных средств -->
    <template v-if="quotation.transport_types_and_kinds && quotation.transport_types_and_kinds.length">
      <p style="margin: 0px 0px 5px 0;"><strong>Необходимые типы и виды транспортных средств:</strong></p>
      <ul style="padding-left: 15px;">
        <li v-for="(transport, index) in quotation.transport_types_and_kinds" :key="`transport_types_and_kinds-${index}`">
          <b style="text-transform: none;">{{ transport.quantity }} шт.</b>&nbsp;{{ transport.transport_category_name }}, {{ transport.transport_item_name }}
        </li>
      </ul>
    </template>    

    <template v-if="quotation.additional_terms">
        <p style="margin: 0px 0px 5px 0;"><strong>Дополнительные условия:</strong> {{ quotation.additional_terms }}</p>
    </template>
      
    <!-- Возят ли в обратном направлении -->
    <template v-if="quotation.reverse_direction === 'Да'">
      <p style="margin: 0px 0px 5px 0;"><strong>Будет обратная загрузка.</strong> {{ quotation.reverse_details }}</p>
    </template>

    <!-- Периодичность поставок -->
    <template v-if="quotation.supply_frequency_id">
      <p style="margin: 0px 0px 5px 0;"><strong>Периодичность поставок:</strong> {{ getReferenceProperty(quotation.supply_frequency_id) }}, количество: {{ quotation.supply_count }}</p>
    </template>

    <!-- Предпочтения по транзиту -->
    <template v-if="quotation.transit_directions_ids && quotation.transit_directions_ids.length">
      <p style="margin: 0px 0px 5px 0;"><strong>Предпочтения по транзиту:</strong> {{ quotation.transit_directions_ids.map(getReferenceProperty).join(', ') }}</p>
    </template>

    <!-- Специальные требования к партнерам -->
    <template v-if="quotation.special_partner_requirements_ids && quotation.special_partner_requirements_ids.length">
      <p style="margin: 0px 0px 5px 0;"><strong>Специальные требования к партнерам:</strong> {{ quotation.special_partner_requirements_ids.map(getReferenceProperty).join(', ') }}</p>
    </template>

    <!-- Стоимость груза -->
    <template v-if="quotation.cargo_invoice_value || quotation.cargo_declared_value">
      <p style="margin: 0px 0px 5px 0;">
        <span v-if="quotation.cargo_invoice_value">
          <strong>Инвойсовая стоимость:</strong> {{ formatNumber(quotation.cargo_invoice_value) }} {{ getReferenceProperty(quotation.cargo_invoice_currency_id) }}
          <span v-if="quotation.cargo_declared_value">, </span>
        </span>
        <span v-if="quotation.cargo_declared_value">
          <strong>Объявленная стоимость:</strong> {{ formatNumber(quotation.cargo_declared_value) }} {{ getReferenceProperty(quotation.cargo_declared_currency_id) }}
        </span>
      </p>
    </template>

    <!-- Условия оплаты -->
    <template v-if="quotation.payment_terms && quotation.payment_terms !== 'Не знаю'">
      <p style="margin: 0px 0px 5px 0;"><strong>Условия оплаты:</strong> {{ quotation.payment_terms }}, <span style="text-transform: lowercase;"> 
        <template v-if="quotation.payment_terms === 'Предоплата'">
          процент предоплаты: {{ quotation.prepayment_percentage }}%, {{ quotation.prepaymentComment }}
        </template>
        <template v-if="quotation.payment_terms === 'Постоплата'">
          {{ quotation.payment_from_copies }}, {{ quotation.payment_period }} {{ formatDays(quotation.payment_period) }} (<span style="text-transform: lowercase;">{{ quotation.payment_period_type }}</span>)
        </template>
      </span></p>
    </template>
    <hr>
    <em>Будем рады оперативно рассмотреть Ваше предложение и предоставить обратную связь!
    <br>Заранее благодарим за ответ и надеемся на взаимовыгодное сотрудничество!</em>

    <!-- Подпись -->
    <div>
      <br>
      --<br>
      <b>С уважением, <br>
      Иван Иванович</b><br>
      Специалист по логистике <br>
      АО "ТАНАИС"<br>
      <br>
      <a href="tel:+79621997929">8(962)199-79-29</a><br>
      <a href="mailto:ivan@eu-tanais.com" class="moz-txt-link-freetext">ivan@eu-tanais.com</a> <br>
      Москва, Горбунова д.2, стр.3<br>
      БЦ "Гранд Сетунь плаза"<br>
      <br>
      <img src="http://eu-tanais.com/logo-tanais.jpg" alt="" width="200"><br>
    </div>
  </div>
</template>

<script>
import { formattedDate } from '@/mixins/textFilters';

export default {
  props: {
    quotation: { type: Object, required: true },
  },
  mixins: [
    formattedDate,
  ],  
  computed: {
    referenceProperties() {
      return this.$store.getters.REFERENCE_PROPERTIES;
    }
  },
  methods: {
    getReferenceProperty(id) {
      return this.referenceProperties[id] ? this.referenceProperties[id].text : 'Неизвестно';
    },
    formatNumber(value) {
      if (typeof value === 'string') {
        const number = parseFloat(value.replace(',', '.'));
        return isNaN(number) ? value : number.toLocaleString();
      }
      return value.toLocaleString();
    },
    formatDays(days) {
      if (days === 1) return 'день';
      if (days >= 2 && days <= 4) return 'дня';
      if (days >= 5 && days <= 20) return 'дней';
      if (days % 10 === 1 && days % 100 !== 11) return 'день';
      if ([2, 3, 4].includes(days % 10) && ![12, 13, 14].includes(days % 100)) return 'дня';
      return 'дней';
    },
  }
};
</script>

<style lang="scss" scoped>
.delivery-quotation-letter {
  line-height: 16px;

  p {
    margin-bottom: 12px;
  }
  b, strong {
    text-transform: none;
  }  

  ul { 
    list-style: disc; 
    margin-left: 25px;
  }
}
</style>
